import React, { useEffect, useState } from 'react';
import { isEmpty, isUndefined } from 'lodash';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import LessonComponentService from '../../../services/LessonComponentService';
import { SelectionComponentProps } from '../../../models/LessonComponent';
import { SelectionOption } from '../../../models/LessonComponentContent';
import styles from '../../../styles/SelectionCard.module.css';
import { useTheme } from '@mui/material';

export default function MultipleSelectionView(props: SelectionComponentProps) {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;
  const { content, settings } = props.component;
  const setSelectionOptions = () => {
    const newOptions = settings?.randomizeOptions
      ? LessonComponentService.randomizeSelectionOptions(content?.options)
      : content?.options;
    return newOptions;
  };

  const [options, setOptions] = useState<SelectionOption[]>(
    setSelectionOptions() || []
  );
  const [selected, setSelected] = useState<string[]>(
    (props.response as string[]) || []
  );

  useEffect(() => {
    if (!isEmpty(options)) {
      return;
    }
    const selectionOptions = setSelectionOptions();
    setOptions(selectionOptions);
  }, [props.component.content?.options]);

  useEffect(() => {
    if (!isUndefined(props.response)) {
      setSelected((props.response as string[]) || []);
    }
  }, [props.response]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const currentSelected = !selected?.includes(value)
      ? [...selected, value]
      : selected?.filter((e) => e !== value);
    props.onChange(currentSelected);
    setSelected(currentSelected);
  };

  return (
    <FormGroup>
      {options?.map((option) => (
        <div
          key={`group-${option.value}`}
          style={{
            ...(settings.selectionSettings?.showBorder &&
              LessonComponentService.optionBorderColor(
                option.value,
                selected,
                primaryColor
              ))
          }}
          className={
            settings.selectionSettings?.showBorder ? styles.labelBorder : ''
          }
        >
          <FormControlLabel
            key={`group-${option.value}`}
            value={option.value}
            control={
              <Checkbox
                color="primary"
                checked={selected?.includes(option.value)}
              />
            }
            label={
              <Box
                className={`${styles.muiFormControlLabel} ${styles.itemLabel}`}
              >
                <span
                  className="formatted-label ql-editor"
                  dangerouslySetInnerHTML={{
                    __html: LessonComponentService.getUrlWithSas(option.label)
                  }}
                ></span>
              </Box>
            }
            onChange={handleChange}
            style={{ width: '100%' }}
          />
        </div>
      ))}
    </FormGroup>
  );
}
